import CheckoutItemLink from "./CheckoutItemLink";

type InfoProps = {
  className?: string;
  locale: string;
  name: string;
  variant?: string | null;
  brand?: string | null;
  slug?: string | null;
};

export default function CheckoutItemName({
  name,
  variant,
  brand,
  className,
  slug,
  locale,
}: InfoProps) {
  return (
    <div className={className}>
      {brand && <span className="text-sm uppercase">{brand}</span>}
      <CheckoutItemLink
        slug={slug}
        locale={locale}
        className="flex flex-col overflow-hidden"
      >
        <span className="truncate">{name}</span>
        {variant && <span className="truncate">{variant}</span>}
      </CheckoutItemLink>
    </div>
  );
}
